import { axiosV2 } from 'interceptors/axios';
import { store } from 'redux/store';
import { decryptResponse } from 'utils/token';

type GetPartnerObservations = {
  partnerId: string;
  societyId: string;
};

export const getPartnerObservations = async ({
  partnerId,
  societyId,
}: GetPartnerObservations) => {
  const query = { params: { partnerId, societyId } };

  try {
    const { data } = await axiosV2.get('/partners/observations', query);

    const decodedData = await decryptResponse(data);

    return decodedData;
  } catch (error) {
    store.dispatchError(error, store.dispatch);
  }
};
